module.exports = __webpack_public_path__ + "img/orange_009.0c907bc0.png";